import { onlyAccept, required } from '../helpers'
import { ValidationFunctions } from '../types'

export const checkboxPromotion: ValidationFunctions = {
  _self: {
    required,
    onlyAccept,
  },
}
